/* eslint-disable no-nested-ternary */
/* eslint-disable object-curly-newline */
import { memo } from 'react';

import Image from 'next/image';

import Link from 'next/link';
import { usePathname } from 'next/navigation';

import './navbarItem.css';

import { routes } from '@/features/v2/constants/routes';
import { cn } from '@/lib/utils';
import { isSportsbookPath, navigateBetbyHome } from '@/utils/betbyNavigation';

import type { MouseEvent } from 'react';
import type { NavbarItemProps } from './interface';

const NavbarItem = ({ href, icon: Icon, isActive, title }: NavbarItemProps) => {
  const pathname = usePathname();

  const getWrapperStyle = () => {
    if (title === 'Deportes' && !isActive) return { marginTop: '0.5rem' };
    if (title === 'Casino' && !isActive) return { marginTop: '0.25rem' };
    return undefined;
  };

  const wrapperClassName = cn('flex items-center justify-center', {
    'icon-deportes-wrapper': title === 'Deportes' && !isActive,
    'icon-casino-wrapper': title === 'Casino' && !isActive,
  });

  const wrapperStyle = getWrapperStyle();

  const handleClick = (event: MouseEvent<HTMLAnchorElement>) => {
    if (href !== routes.SPORTS || !isSportsbookPath(pathname)) {
      return;
    }

    if (navigateBetbyHome()) {
      event.preventDefault();
    }
  };

  return (
    <li className="list-none">
      <Link
        href={href}
        prefetch
        onClick={handleClick}
        className={cn(
          'flex items-center justify-center py-1 font-semibold  rounded-full transition-all ease-in-out duration-300',
          {
            'navbar-item-active': isActive,
            'navbar-item-inactive ': !isActive && href !== routes.DASHBOARD && href !== routes.LOGIN,
            'text-default-900': !isActive,
          },
        )}
      >
        {typeof Icon === 'string' ? (
          <div className={wrapperClassName} style={wrapperStyle}>
            <Image
              src={Icon}
              alt={title}
              width={28}
              height={28}
              sizes="30px"
              priority
              style={{ width: 28, height: 28 }}
              className="flex items-center justify-center"
            />
          </div>
        ) : Icon && typeof Icon === 'function' ? (
          Icon({})
        ) : (
          <div className={wrapperClassName} style={wrapperStyle}>
            {Icon}
          </div>
        )}
        {isActive && <span className="text-sm">{title}</span>}
      </Link>
    </li>
  );
};

export default memo(NavbarItem);
